import { render, staticRenderFns } from "./PatientData.vue?vue&type=template&id=4898c12b&scoped=true&"
import script from "./PatientData.vue?vue&type=script&lang=js&"
export * from "./PatientData.vue?vue&type=script&lang=js&"
import style0 from "./PatientData.vue?vue&type=style&index=0&id=4898c12b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898c12b",
  null
  
)

export default component.exports